import cls from 'classnames';
import { useTranslation } from 'next-i18next';
import { useEffect, useState, useMemo } from 'react';

import styles from './index.module.scss';
import { CFG_SCALE_STEPS_MAP } from '../../../constants/image';
import { useAppDispatch, useAppSelector } from '../../../state';
import { setImgPreviewExtra } from '../../../state/image';
import { track } from '../../../track';

export function CFGScaleInput({ source }: { source: string }) {
  const {
    modelType,
    imgConfig: { web_preview_extra },
  } = useAppSelector((state) => state.image);
  const { t } = useTranslation();

  const cfgScale = useMemo(() => {
    return web_preview_extra?.cfg_scale;
  }, [web_preview_extra]);

  const dispatch = useAppDispatch();

  const onCfgScaleChange = (value: number) => {
    track.send('cfg_scale_input', source, {
      cfg_scale_value: value,
    });
    dispatch(
      setImgPreviewExtra({
        cfg_scale: value,
      })
    );
  };

  return (
    <div className={styles.cfgScale}>
      <div
        className={cls(
          styles.btn,
          cfgScale === CFG_SCALE_STEPS_MAP[modelType].low && styles.active
        )}
        onClick={() => onCfgScaleChange(CFG_SCALE_STEPS_MAP[modelType].low)}
      >
        {t('cfg_scale_low')}
      </div>
      <div
        className={cls(
          styles.btn,
          cfgScale === CFG_SCALE_STEPS_MAP[modelType].mid && styles.active
        )}
        onClick={() => onCfgScaleChange(CFG_SCALE_STEPS_MAP[modelType].mid)}
      >
        {t('cfg_scale_mid')}
      </div>
      <div
        className={cls(
          styles.btn,
          cfgScale === CFG_SCALE_STEPS_MAP[modelType].high && styles.active
        )}
        onClick={() => onCfgScaleChange(CFG_SCALE_STEPS_MAP[modelType].high)}
      >
        {t('cfg_scale_high')}
      </div>
    </div>
  );
}
